import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Loader2 } from "lucide-react";

type ClipboardCreateFolderDialogProps = {
  open: boolean;
  creating: boolean;
  folderName: string;
  folderError: string | null;
  canSubmit: boolean;
  onOpenChange: (open: boolean) => void;
  onFolderNameChange: (value: string) => void;
  onSubmit: (event: React.FormEvent) => void;
};

export const ClipboardCreateFolderDialog = ({
  open,
  creating,
  folderName,
  folderError,
  canSubmit,
  onOpenChange,
  onFolderNameChange,
  onSubmit,
}: ClipboardCreateFolderDialogProps) => (
  <Dialog open={open} onOpenChange={(o) => !creating && onOpenChange(o)}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>New clipboard folder</DialogTitle>
        <DialogDescription>
          Create a folder to organize papers. You can link corpus papers, upload PDFs, or
          import a .bib file into it.
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-3">
        {folderError != null && (
          <p id="new-folder-error" className="text-sm text-red-700" role="alert">
            {folderError}
          </p>
        )}
        <label className="block space-y-1" htmlFor="new-folder-name">
          <span className="text-sm font-medium text-zinc-500">Folder name</span>
          <Input
            id="new-folder-name"
            value={folderName}
            onChange={(e) => onFolderNameChange(e.target.value)}
            placeholder="lit-review"
            required
            autoFocus
            aria-invalid={folderError != null}
            aria-describedby={folderError != null ? "new-folder-error" : undefined}
          />
        </label>
        <div className="flex justify-end gap-2 pt-2">
          <Button
            type="button"
            variant="ghost"
            onClick={() => onOpenChange(false)}
            disabled={creating}
          >
            Cancel
          </Button>
          <Button type="submit" disabled={creating || !canSubmit}>
            {creating ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Creating…
              </>
            ) : (
              "Create"
            )}
          </Button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);
